import React, { useEffect, useState } from 'react';
import '../css/main.css';
import wakerBurn from '../Images/ISC-Realty-Properties.jpg';
import BResidence from '../Images/Brigade.jpg';
import Icon from '../Images/IconBySynchron.jpg';
import {validation} from '../components/validation';
import PropertyExchangeImage from '../Images/ISC-PropEx-FormBG-Image.jpg';
import PlotExchange from '../components/actions';
import {appendScript} from '../scriptAdded';
import PageBannerImage from '../Images/ISC-PropEx-BG-Image.jpg';
import { BrowserRouter as Router, Redirect, Route, useLocation } from 'react-router-dom';


import axios from 'axios';
import { Link } from 'react-router-dom';
export const AboutIsc = () =>{
    return(
        <>
           <section  className="about-isc" id="about">
               <div className="container">
                   <div className="row">
                       <div className="col-md-12 col-lg-12">
                           <h4 className="page-title">About ISC <span>PropEX</span></h4>
                           <p><strong>ISC PropEx</strong> is a service from the house of ISC Realty, apart from being a high profile channel partner for many builders, <strong>ISC</strong> is rolling out its own products and services in the <strong>REALTY</strong> and ancillary spaces. Look out for this space for more announcements.</p>
                       </div>
                   </div>
               </div>
           </section>

        </>
    )
}
export const PropertyExchange = () =>{
    const [exchangeForm, setexchangeForm]=useState({name:'',formComesFrom:'Property Exchange',mobileNumber:'',email:'',plot:'Plot or Land',plotNo:'',units:'2',pricePerUnit:'2000000',totalPrice:'4000000',selectedFile:null,legalOwner:false,documentValuation:false,propExProcess:false,successMessage:'',fileName:''});
    const [errors,seterrors]=useState({});
    
    const uploadPropertyValue = e =>{
        
        setexchangeForm({...exchangeForm,selectedFile:e.target.files[0]})

         console.log(exchangeForm.selectedFile)
         
    }
    
    const ExchangeSubmission = async e =>{
        e.preventDefault();
        setexchangeForm({
            ...exchangeForm,
            totalPrice:exchangeForm.pricePerUnit * exchangeForm.units
        }) 
        
        const validationErrors = validation(exchangeForm);
             seterrors({
                ...errors,
                validationErrors
    
            })
		const noErrors = Object.keys(validationErrors).length === 0;
        
        
        console.log(errors);
        if(noErrors){
            PlotExchange(exchangeForm).then((res) => {
                if(res.data.success===1){
                    setexchangeForm({
                        ...exchangeForm,
                        successMessage:res.data.message
                      })
                      alert(res.data.message);
                      window.location.reload(true);
                      
                      
                 
                 
                }
                else{
                    setexchangeForm({
                    ...exchangeForm,
                    successMessage:res.data.errorMessage
                  })
                }
               
           
           })
           .catch(error => {
                
             }
             );
		}else{
             alert('please fill up the complete form');
             
             
		} 
        
    
    }
    
    return (
         <>
           <section className="propertyExchange" id="propertyExchange" style={{backgroundImage:`url(${PropertyExchangeImage})`,backgroundSize:"cover"}}>
               <div className="container">
                   <div className="row">
                       <div className="col-md-12 col-lg-12">
                           <h4 className="property-title"><span>I want to exchange</span><br/>
                            My Property for buying a New Property</h4>
                       </div>
                   </div>
                   <form onSubmit={ExchangeSubmission}>
                   <div className="row" style={{marginTop:"40px"}}>
                       <div className="col-md-6 col-lg-6">
                           <section className="form">
                               
                               <div className="form-group">
                                   <input type="text" className="form-control" placeholder="Name" onChange={e =>setexchangeForm({...exchangeForm,name : e.target.value})} value={exchangeForm.name}></input>
                                   
                               </div>
                               <div className="form-group">
                                   <input type="number" className="form-control" placeholder="Mobile Number" onChange={e =>setexchangeForm({...exchangeForm,mobileNumber:e.target.type==='number' ? parseInt(e.target.value):e.target.value })} value={exchangeForm.mobileNumber}></input>
                                   
                               </div>
                               <div className="form-group">
                                   <input type="email" className="form-control" placeholder="Email" onChange={e =>setexchangeForm({...exchangeForm,email:e.target.value})} value={exchangeForm.email}></input>
                                   
                               </div>
                               <div className="form-group">
                                    <select id="inputState" class="form-control" onChange={e=>setexchangeForm({...exchangeForm,plot:e.target.value})} value={exchangeForm.plot}>
                                        <option value="Plot or Land">Plot or Land</option>
                                        <option>Constructed Space</option>
                                    </select>
                                    
                               </div>
                               
                               <div className="row">
                                    <div className="col-6">
                                        <div className="form-group">
                                            <label>&nbsp;&nbsp;</label><br/>
                                            <input type="text" className="form-control" placeholder="Plot no / flat no" onChange={e=>setexchangeForm({...exchangeForm,plotNo:e.target.value})} value={exchangeForm.plotNo}></input>
                                            
                                        </div>
                                    </div>
                                    {
                                    exchangeForm.plot==='Plot or Land' ?
                                    <div className="col-6">
                                        <div className="form-group">
                                            <label>Sq. Yd.</label><br/>
                                             <input type="number" className="form-control" placeholder="Units (sq ft, Sq Yd, Cents, Acres)" onChange={e =>setexchangeForm({...exchangeForm,units:e.target.type==='number' ? parseInt(e.target.value):e.target.value })} value={exchangeForm.units} />
                                        
                                        </div>
                                    </div>
                                    :
                                    <div className="col-6">
                                    <div className="form-group">
                                       <label>Sq. Ft.</label><br/>
                                         <input type="number" className="form-control" placeholder="Units (sq ft)" onChange={e =>setexchangeForm({...exchangeForm,units:e.target.type==='number' ? parseInt(e.target.value):e.target.value })} value={exchangeForm.units} />
                                    
                                    </div>
                                    </div>
                                    }
                                
                                </div>
                                <div className="form-group">
                                {
                                    exchangeForm.plot==='Plot or Land' ?
                                    <label>Price Per Sq. Yd.</label>
                                    : <label>Price Per Sq. Ft.</label>
                                }
                                   <input type="number" className="form-control" placeholder="Price Per Unit" onChange={e =>setexchangeForm({...exchangeForm,pricePerUnit:e.target.type==='number' ? parseInt(e.target.value):e.target.value })} value={exchangeForm.pricePerUnit}></input>
                                      </div>
                                      
                               <div class="button-wrap">
                                    <label class="file-button" for="upload">Upload Property Photo</label>
                                    <input id="upload" type="file" onChange={uploadPropertyValue}/>
                                    
                                </div>
                               

                           </section>
                           
                       </div>
                       <div className="col-md-6 col-lg-6 align-center">
                           <h4 className="price">
                               <span>Total Price</span><br/>
                               &#8377; {exchangeForm.pricePerUnit * exchangeForm.units}
                           </h4>
                           <div className="checbox-form">
                                <div class="form-check mb-2 mr-sm-2">
                                    <input className="form-check-input" type="checkbox" id="inlineFormCheck"name="legalOwner" onChange={e=>setexchangeForm({...exchangeForm,legalOwner:e.target.checked})} value={exchangeForm.legalOwner} />
                                    <label className="form-check-label">
                                    I am the legal owner of the property<br/>
                                    <span>( Brokers can contact +91 994 380 9000)</span>
                                    </label>

                                </div>
                                
                                <div class="form-check mb-2 mr-sm-2">
                                    <input className="form-check-input" type="checkbox" id="inlineFormCheck" name="documentValuation" onChange={e=>setexchangeForm({...exchangeForm,documentValuation:e.target.checked})}/>
                                    <label className="form-check-label" >
                                    I want to submit my documents for valuation </label>
                                </div>
                                <div class="form-check mb-2 mr-sm-2">
                                    <input className="form-check-input" type="checkbox" id="inlineFormCheck" name="propExProcess" onChange={e=>setexchangeForm({...exchangeForm,propExProcess:e.target.checked})}/>
                                    <label className="form-check-label" >
                                    I want to receive a call regarding PropEx process</label>
                                </div>
                                
                           </div>
                           <p style={{color:"#fff",fontSize:"18px",textAlign:"center" }}>{exchangeForm.successMessage}</p>
                           <div className="submit-button">
                               <input type="submit" className="btn btn-lg btn-submit" value="submit" />
                           </div>

                       </div>
                   </div>
                   </form>
               </div>
           </section>

         </>
     )
     
}
export const Propertyavailableexchange = () =>{
    useEffect(() => {
        
        appendScript(`${process.env.PUBLIC_URL+'/main.js'}`);
        
    });
         return (
             <>
               <section className="available-properties">
                   <div className="container">
                       <div className="row">
                           <div className="col-md-12 col-lg-12">
                               <h4 className="available-properity-title"><span>Properties</span><br/>
                               Available <strong>for exchange</strong></h4>
                           </div>
                       </div>
                       <div className="row" style={{marginTop:"40px"}}>
                           <div className="owl-carousel owl-theme">
                                <div className="item">
                                  <Link to={process.env.PUBLIC_URL+'/property-list/WalkerBurn'}>
                                    <img src={wakerBurn} alt="wakerBurn" className="propertyImage" />
                                    </Link>
                               </div>
                                <div className="item">
                                   <Link to={process.env.PUBLIC_URL+'/property-list/BrigadeResidences'}>
                                       <img src={BResidence} alt="wakerBurn" className="propertyImage" />
                                    </Link>
                                </div>
                                <div className="item">
                                   <Link to={process.env.PUBLIC_URL+'/property-list/ICON by Synchron'}>
                                      <img src={Icon} alt="wakerBurn" className="propertyImage" />
                                    </Link>
                                </div>
                            </div>
                       </div>
                   </div>
               </section>
               
             </>
         )        
} 
export const KnowMoreIsc = () =>{
    return(
        <>
           <section className="knowMoreIsc" id="contact">
              <div className="container">
                  <div className="row justify-center">
                      <div className="col-md-10 col-lg-10">
                          <div className="knowmore-block">
                           <h4 className="knowmoreText">To know more about ISC PropEx</h4>
                           <div className="call-button">
                               <a href="tel:+919943809000" className="btn btn-lg">Call : +91 994 380 9000</a>
                           </div>
                           </div>
                           <div className="row" style={{marginTop:"30px"}}>
                               <div className="col-md-5 col-lg-5">
                                   <h4 className="footer-title">@2020 ISC PropEX. All Rights Reserved</h4>
                               </div>
                               <div className="col-md-7 col-lg-7 text-end">
                                   <h4 className="footer-title"><a>Terms & Conditions</a><a href={`${process.env.PUBLIC_URL}/privacy-policy`} style={{color:"#fff"}}>Privacy Policy</a><a href={`${process.env.PUBLIC_URL}/#contact`} style={{color:"#fff"}}>Contact us</a></h4>
                               </div>
                           </div>
                      </div>
                  </div>
              </div>
           </section>
        </>
    )
}
export const PropertryListDetailsBanner  = () =>{
    return (
        <section className="propertyListBanner jumbotron" style={{backgroundImage:`url(${PageBannerImage})`,backgroundSize:"cover"}}>
            <div className="container">
                <div className="row">
                    <div className="col-md-12 col-lg-12">
                        <h4 className="property-list-details-title">WalkerBurn</h4>
                    </div>
                </div>
            </div>
        </section>
    )
}
export const NoMatch = () =>{
    let location = useLocation();
    return (
      <Redirect to="/isc-reality/property-list"></Redirect>
    );
  }
